import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';

export class RowRenderer extends Component {
  
  render() {
    return (
      <div onDoubleClick={() => { this.props.onDoubleClick(this.props.row, this.props.from, this.props.to )}}>
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

export default RowRenderer;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/rowRenderer.jsx